import SidebarNavigation from './SidebarNavigation';

const SidebarRightNavigation = (props: any) => {
  return <SidebarNavigation {...props} />;
};

export default SidebarRightNavigation;
